export const isUserInRole = (keycloak: any, role: string) => {
  if (keycloak.token === undefined) {
    return false;
  } else {
    const venusResourceAccess = keycloak.tokenParsed['resource_access']['venus-service'];
    if (venusResourceAccess === undefined) {
      return null;
    } else {
      const roles: string[] = venusResourceAccess['roles'];
      return roles.includes(role);
    }
  }
};